export var increment = function (value, maxValue) {
    if (value === void 0) { value = 0; }
    return maxValue === undefined ? value + 1 : Math.min(value + 1, maxValue);
};
export var decrement = function (value, minValue) {
    if (value === void 0) { value = 0; }
    return minValue === undefined ? value - 1 : Math.max(value - 1, minValue);
};
export var setInputValue = function (value) {
    if (value === undefined) {
        return '';
    }
    return value;
};
//# sourceMappingURL=AmountPicker.utils.js.map